// extracted by mini-css-extract-plugin
module.exports = {"container":"flags_container__vY5WV","flag-icon":"flags_flag-icon__Tpz7i","flagIcon":"flags_flag-icon__Tpz7i"};